export const TYPE_OPTIONS = [
  'heart',
  'star',
  'radio'
]
